var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserLead(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33.292,
    height: 36.833,
    viewBox: "0 0 33.292 36.833",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_77",
    x: 0,
    y: 0,
    width: 27.644,
    height: 36.833,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#50b2dc",
    floodOpacity: 0.459
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_78",
    x: 15.308,
    y: 18.622,
    width: 17.984,
    height: 14.417,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#50b2dc",
    floodOpacity: 0.459
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_79",
    x: 15.307,
    y: 14.818,
    width: 17.985,
    height: 14.419,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#50b2dc",
    floodOpacity: 0.459
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_80",
    x: 15.307,
    y: 22.424,
    width: 17.985,
    height: 14.409,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#50b2dc",
    floodOpacity: 0.459
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_41",
    "data-name": "Groupe 41",
    transform: "translate(465.628 19)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -465.63, -19)",
    filter: "url(#Trac\\xE9_77)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_77-2",
    "data-name": "Trac\\xE9 77",
    d: "M-448.433-19c.5.109,1.015.177,1.5.335a6.452,6.452,0,0,1,4.43,6.537,6.457,6.457,0,0,1-5.428,5.965,6.632,6.632,0,0,1-1.063.086,10.5,10.5,0,0,0-10.2,8.3.986.986,0,0,0,1.018,1.206q3.683,0,7.366,0h2.02a.971.971,0,0,1,1.058.787.963.963,0,0,1-.709,1.087.191.191,0,0,0-.039.027H-458.6a.9.9,0,0,0-.131-.044,2.866,2.866,0,0,1-2.323-3.434,12.23,12.23,0,0,1,7-8.726c.39-.185.8-.328,1.214-.5-.048-.043-.081-.076-.117-.106a6.222,6.222,0,0,1-2.4-5.767,6.221,6.221,0,0,1,4.252-5.374A12.113,12.113,0,0,1-449.478-19Zm4.039,6.465a4.569,4.569,0,0,0-4.56-4.564,4.569,4.569,0,0,0-4.565,4.56,4.57,4.57,0,0,0,4.655,4.563A4.572,4.572,0,0,0-444.393-12.535Z",
    transform: "translate(465.63 19)",
    fill: "#50b2dc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -465.63, -19)",
    filter: "url(#Trac\\xE9_78)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_78-2",
    "data-name": "Trac\\xE9 78",
    d: "M-130.043,374.165a1.259,1.259,0,0,1-1.225.578c-2.216-.018-4.433-.007-6.65-.009a1.631,1.631,0,0,1-.4-.038.939.939,0,0,1-.7-1.019.944.944,0,0,1,.914-.839c.459-.01.918,0,1.377,0,1.821,0,3.642.013,5.462-.008a1.243,1.243,0,0,1,1.224.578Z",
    transform: "translate(158.84 -354.2)",
    fill: "#50b2dc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -465.63, -19)",
    filter: "url(#Trac\\xE9_79)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_79-2",
    "data-name": "Trac\\xE9 79",
    d: "M-130.062,294.124a1.253,1.253,0,0,1-1.225.578c-2.248-.019-4.5-.007-6.745-.009a.953.953,0,0,1-.959-1.264.957.957,0,0,1,.959-.635q2.66,0,5.32,0c.475,0,.951.023,1.425-.006a1.2,1.2,0,0,1,1.225.576Z",
    transform: "translate(158.85 -277.97)",
    fill: "#50b2dc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -465.63, -19)",
    filter: "url(#Trac\\xE9_80)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_80-2",
    "data-name": "Trac\\xE9 80",
    d: "M-138.29,454.732l-.151-.063a.959.959,0,0,1-.6-1.049.946.946,0,0,1,.936-.788c.831-.006,1.661,0,2.492,0,1.44,0,2.88.015,4.319-.008a1.242,1.242,0,0,1,1.224.578v.76a1.309,1.309,0,0,1-.713.57Z",
    transform: "translate(158.86 -430.4)",
    fill: "#50b2dc"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLead);
export default __webpack_public_path__ + "static/media/user-lead.9e44e3fde3fd1457f6876094b9fccb38.svg";
export { ForwardRef as ReactComponent };